<template>
    <template v-for="(linkdata, i) in propertyTypeData" :key="i">
        <section v-if="linkdata.show">
          <div class="grid fixed fixed-max-sm xs-grid-cols-1 gap-3">
            <mvtCollapsibleLinks
                :title="linkdata.title"
                titleClass="f3 text-capitalize text-bold p-y-2"
                :links='linkdata.data.map(item => { return {url: item.href, text: item.title} })'
            />
          </div>
        </section>
    </template>
</template>

<script src="./sitemap-propertytypes.js"></script>
